export default __webpack_public_path__ + "static/media/03n.61981d54.png";